/* eslint-disable react/no-array-index-key */
import {
  Table,
  TableBody,
  tableBodyClasses,
  TableCell,
  tableCellClasses,
  TableHead,
  tableHeadClasses,
  TableProps,
  TableRow,
  tableRowClasses,
} from '@mui/material';
import { WeatherStationHistoricalData } from 'features/weatherStations/weatherStations.types';

type WeatherStationDataTableProps = {
  data: WeatherStationHistoricalData;
};

const tableSx: TableProps['sx'] = {
  [`& .${tableCellClasses.root}`]: {
    borderBottom: 'none',
    padding: 0,
    fontSize: 12,
    height: 32,
    textAlign: 'center',
    width: 40,
  },
  [`& .${tableHeadClasses.root} .${tableRowClasses.root}:first-of-type .${tableCellClasses.root}`]:
    {
      fontSize: 8,
      height: 17,
    },
  [`& .${tableHeadClasses.root} .${tableRowClasses.root} .${tableCellClasses.root}:first-of-type`]:
    {
      borderRight: (theme) => `1px solid ${theme.palette.divider}`,
    },
  [`& .${tableBodyClasses.root} .${tableRowClasses.root} .${tableCellClasses.root}:first-of-type`]:
    {
      fontWeight: 'fontWeightBold',
      borderRight: (theme) => `1px solid ${theme.palette.divider}`,
    },
  [`& .${tableBodyClasses.root} .${tableRowClasses.root} .${tableCellClasses.root}:not(:first-of-type)`]:
    {
      fontSize: 14,
    },
};

export const WeatherStationDataTable = (
  props: WeatherStationDataTableProps,
): JSX.Element => {
  const {
    data: { head, data },
  } = props;

  return (
    <Table size="small" sx={tableSx}>
      <TableHead>
        <TableRow>
          {head.map((value, index) => (
            <TableCell key={`${head}-${index}`}>{value}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((rows, rowIndex) => {
          return (
            <TableRow key={`body-row-${rowIndex}`}>
              {rows.map((cell, columnIndex) => {
                return (
                  <TableCell
                    key={`body-cell-${rowIndex}-${columnIndex}`}
                    sx={cell.tableCellSx}
                  >
                    {cell.value}
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
